import { createContext, useContext, useReducer, useCallback } from 'react';

const MAX_EVENTS = 200;
let _idCounter = 0;

export const SEVERITY = {
  INFO:     'info',
  NOTICE:   'notice',
  WARNING:  'warning',
  CRITICAL: 'critical',
};

export const CATEGORY = {
  SPACEWEATHER: 'spaceweather',
  CONJUNCTION:  'conjunction',
  REENTRY:      'reentry',
  AVIATION:     'aviation',
  ISS:          'iss',
  PASS:         'pass',
  INGEST:       'ingest',
  SYSTEM:       'system',
};

const SEVERITY_COLOR = {
  info:     '#475569',
  notice:   '#3b82f6',
  warning:  '#f59e0b',
  critical: '#ef4444',
};

export function severityColor(s) { return SEVERITY_COLOR[s] || SEVERITY_COLOR.info; }

function reducer(state, action) {
  switch (action.type) {
    case 'PUSH': {
      const event = {
        id:           ++_idCounter,
        ts:           Date.now(),
        severity:     action.severity || SEVERITY.INFO,
        category:     action.category || CATEGORY.SYSTEM,
        title:        action.title    || '',
        body:         action.body     || '',
        norad_1:      action.norad_1  || null,
        norad_2:      action.norad_2  || null,
        lat:          action.lat      || null,
        lon:          action.lon      || null,
        acknowledged: false,
      };
      return { ...state, events: [event, ...state.events].slice(0, MAX_EVENTS) };
    }
    case 'ACK':
      return { ...state, events: state.events.map(e => e.id === action.id ? { ...e, acknowledged: true } : e) };
    case 'ACK_ALL':
      return { ...state, events: state.events.map(e => ({ ...e, acknowledged: true })) };
    case 'CLEAR':
      return { ...state, events: [] };
    default:
      return state;
  }
}

export const EventBusContext = createContext(null);

export function createEventBusState() {
  return useReducer(reducer, { events: [] });
}

export function useEventBus() {
  const ctx = useContext(EventBusContext);
  if (!ctx) throw new Error('useEventBus must be inside EventBusProvider');
  return ctx;
}

export function useUnacknowledgedCount() {
  const { events } = useEventBus();
  return events.filter(e => !e.acknowledged).length;
}
